import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsCivilStatusFatherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared isFather scope={IdAmbito.Iscrizioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusFatherPage.displayName =
  'Research Family Notifications CivilStatusFatherPage component';

export default ResearchFamilyNotificationsCivilStatusFatherPage;
